var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-btn',{attrs:{"color":"error","icon":""},on:{"click":_vm.redirectToProFemina}},[_c('v-icon',{attrs:{"large":_vm.$vuetify.breakpoint.smAndUp,"color":"close"}},[_vm._v(" "+_vm._s(("mdi-" + _vm.iconText))+" ")])],1)}
var staticRenderFns = []

export { render, staticRenderFns }